module.exports = __webpack_public_path__ + "img/illustration-simple-ui.cc78ad5b.svg";